import{post } from '@/utils/request';
import{overseasserver,erpserver,erpplatserver} from '@/utils/baseUrl';

//品种列表
export async function productlist(params) {
    return post(overseasserver+'/product/list', params, true)
}
//币种
export async function bzList(params) {
    return post(overseasserver+'/currency/bzList', params, true)
}
//付款
export async function payType(params) {
    return post(overseasserver+'/currency/payType', params, true)
}

//仓库列表
export async function warehouselist(params) {
    return post(overseasserver+'/warehouse/list', params, true)
}
//客商列表查询
export async function list(params) {
    return post(overseasserver+'/kh/list', params, true)
}

//公司列表
export async function companylist(params) {
    return post(overseasserver+'/company/list', params, true)
}
//保存成本预估
export async function sellsave(params) {
    return post(overseasserver+'/sell/save', params, true)
}
//成本预估列表
export async function selllist(params) {
    return post(overseasserver+'/sell/list', params, true)
}
//上传图片-new
export async function uploadInvoice(params) {
    return post(erpplatserver+'/system/uploadInvoice',params,false);
}



